function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pin_new_svg__clip0_885_1358)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 9.333c2.195.46 3.334 1.416 3.334 2.52 0 1.554-2.985 2.814-6.667 2.814s-6.667-1.26-6.667-2.813c0-1.105 1.138-2.06 3.334-2.52M8 8a3.333 3.333 0 100-6.667A3.333 3.333 0 008 8zm0 0v4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pin_new_svg__clip0_885_1358"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

var SvgPinNew = function SvgPinNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#2F384C"
  }, props), _ref, _ref2);
};

export default SvgPinNew;